module.exports = __webpack_public_path__ + "static/media/tanda_tangan_digital_20161124_192811.0213806f.jpg";